import React from 'react';
import TwoFactorAuthSettings from '../../shared/TwoFactorAuthSettings';

/** Vendor settings tab — same 2FA flow as admin/client via /user/two-factor. */
const TwoFactorAuthTab = () => (
  <TwoFactorAuthSettings queryKey="vendor-two-factor-status" />
);

export default TwoFactorAuthTab;
